import { useEffect } from "react";

// disables page scrolling, compensates for scrollbar width to prevent layout shift
const lockScroll = () => {
  if (typeof document === "undefined") return;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
  document.documentElement.classList.add("no-scroll");
};

// re-enables page scrolling
const unlockScroll = () => {
  if (typeof document === "undefined") return;
  document.documentElement.classList.remove("no-scroll");
  document.documentElement.style.paddingRight = "";
};

export const useScrollLock = (shouldLock) => {
  useEffect(() => {
    if (shouldLock) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => unlockScroll();
  }, [shouldLock]);
};
